export default "__VITE_ASSET__D0wCREu7__"